import css from "./index.module.css";
import * as Types from "../../types";

function formatDate(dateString?: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const mins = String(date.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} ${hours}:${mins}`;
}

function isImageUrl(url: string = ""): boolean {
  return /\.(jpeg|jpg|png|gif|bmp|svg|webp)$/i.test(url.split("?")[0]);
}

function getFileName(url: string = ""): string {
  try {
    return decodeURIComponent(url.split("/").pop()?.split("?")[0] || "Файл");
  } catch {
    return "Файл";
  }
}

export default function ChatMessage({
  item,
  isFromMe,
  renderMode = "desktop",
}: {
  item: Types.Message;
  isFromMe: boolean;
  renderMode?: "desktop" | "mobile";
}) {
  const messageClass =
    renderMode === "mobile"
      ? `${css.mobileMessage} ${
          isFromMe ? css.mobileMessageFrom : css.mobileMessageTo
        }`
      : isFromMe
      ? css.from
      : css.to;

  const isFile = item.msgType === 1;
  const isImage = isFile && isImageUrl(item.msg);
  const isOnlyFile = isFile && !isImage;

  return (
    <div className={messageClass}>
      <div
        className={
          renderMode === "mobile" ? css.mobileMessageBubble : css.messageBubble
        }
        style={{
          borderRadius: "15px",
          padding: renderMode === "mobile" ? "10px 10px 7px" : "12px 14px 8px",
          marginBottom: 6,
          background: isFromMe
            ? "var(--bubble-me-bg, #E0F6E9)"
            : "var(--bubble-from-bg, #F1F0F0)",
          color: "#222",
          maxWidth: renderMode === "mobile" ? "85%" : "70%",
          boxShadow:
            "0 1px 2px 0 rgba(34, 34, 34, .05), 0 0.5px 1.5px 0 rgba(34, 34, 34, .01)",
          alignSelf: "flex-start",
        }}
      >
        {item.msgType === 0 && (
          <div
            style={{
              whiteSpace: "pre-line",
              wordBreak: "break-word",
              fontSize: renderMode === "mobile" ? 15 : 15.5,
            }}
          >
            {item.msg}
          </div>
        )}
        {isImage && (
          <a
            href={item.msg}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", margin: "5px 0" }}
          >
            <img
              src={item.msg}
              alt={getFileName(item.msg)}
              style={{
                maxWidth: renderMode === "mobile" ? "160px" : "220px",
                maxHeight: renderMode === "mobile" ? "160px" : "220px",
                borderRadius: 7,
                boxShadow: "0 0 4px rgba(0,0,0,0.10)",
                display: "block",
              }}
              loading="lazy"
            />
          </a>
        )}

        {isOnlyFile && (
          <a
            href={item.msg}
            download
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              color: "#235ed6",
              background: "#eef2ff",
              padding: "7px 12px",
              borderRadius: 9,
              fontSize: renderMode === "mobile" ? 15 : 15.5,
              textDecoration: "none",
              boxSizing: "border-box",
              width: "100%",
            }}
            className={
              renderMode === "mobile" ? css.mobileFileBubble : css.fileBubble
            }
          >
            <i className="fi fi-rr-download" style={{ fontSize: 17 }} />
            <span
              style={{
                maxWidth: 170,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {getFileName(item.msg)}
            </span>
          </a>
        )}
        <div
          style={{
            textAlign: "right",
            fontSize: renderMode === "mobile" ? 11 : 12,
            color: "#969696",
            marginTop: 4,
            minHeight: "14px",
            userSelect: "none",
          }}
        >
          {formatDate(item.createdAt)}
        </div>
      </div>
    </div>
  );
}
